import React from "react";
import AdminPurchaseAccountsComp from "../../components/Admin/AdminPurchaseAccounts";

export default function AdminPurchaseAccountsPage() {
  return <AdminPurchaseAccountsComp />;
}
